import { render } from "./List.vue?vue&type=template&id=e2ffe7be"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/TasksPriorities/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2ffe7be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2ffe7be', __exports__)) {
    api.reload('e2ffe7be', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=e2ffe7be", () => {
    api.rerender('e2ffe7be', render)
  })

}


export default __exports__